import { AttachmentFileType } from '../types/AttachmentFile';
import { trace } from 'owa-trace';
export default function createMailItemFiles(subjects, latestItemIds) {
    if (subjects.length != latestItemIds.length) {
        trace.error('The sizes of subjects and latestItemIds are different');
        return null;
    }
    var mailItemList = [];
    for (var i = 0; i < subjects.length; i++) {
        var conversation = {
            fileType: AttachmentFileType.MailItem,
            name: subjects[i],
            size: 0,
            itemId: latestItemIds[i],
        };
        mailItemList.push(conversation);
    }
    return mailItemList;
}
//# sourceMappingURL=createMailItemFiles.js.map